import React, {useEffect, useState, useRef} from "react";
import {connect} from "react-redux";
import AuthenticationService from "../../../services/Authentication/AuthenticationService";
import UserService from "../../../services/UserService";
import {withToastManager} from "react-toast-notifications";
import {isPasswordValid} from "../../../utils/BubblyUtils";
import {buildCSSFormGroupInput, buildCSSFormGroupInputTarget} from "../../../utils/BubblyUIUtils";
import LoadingIndicator from "../../meta/LoadingIndicator";

function CredentialsSection(props) {
    const [userEmail, setUserEmail] = useState("");
    const [displayChangePassword, setDisplayChangePassword] = useState(false);
    const [oldPassword, setOldPassword] = useState("");
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [isOldPasswordValid, setIsOldPasswordValid] = useState(true);
    const [newPassword, setNewPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [isNewPasswordValid, setIsNewPasswordValid] = useState(true);
    const [savingNewPassword, setSavingNewPassword] = useState(false);
    const oldPasswordInput = useRef();

    useEffect(() => {
        AuthenticationService.getUserEmail(props.userId, (success) => {
            setUserEmail(success.data['email']);
        });
    }, []);

    function openChangePasswordForm(e) {
        e.preventDefault();
        setDisplayChangePassword(true);
    }

    function onChangeOldPassword(e) {
        const oldPass = e.target.value;
        setOldPassword(oldPass);

        if (!isOldPasswordValid) {
            setIsOldPasswordValid(true);
            buildCSSFormGroupInput(e, "changePasswordOldPasswordFormGroup", "changePasswordOldPasswordFormGroupError", true);
        }
    }

    function toggleShowOldPassword() {
        setShowOldPassword(!showOldPassword);
    }

    function onChangeNewPassword(e) {
        const newPass = e.target.value;
        setNewPassword(newPass);

        const passValid = isPasswordValid(newPass);
        setIsNewPasswordValid(passValid);
        buildCSSFormGroupInput(e, "changePasswordNewPasswordFormGroup", "changePasswordNewPasswordFormGroupError", passValid);
    }

    function toggleShowNewPassword() {
        setShowNewPassword(!showNewPassword);
    }

    function onSaveButtonClick(e) {
        e.preventDefault();

        if (isOldPasswordValid && isNewPasswordValid) {
            setSavingNewPassword(true);
            const changeUserPasswordPayload = {
                user_password_old: oldPassword,
                user_password_new: newPassword
            };
            UserService.changePassword(props.userId, changeUserPasswordPayload, () => {
                props.toastManager.add("The password was successfully changed.", {
                    appearance: 'success'
                });
                setOldPassword("");
                setNewPassword("");
                setDisplayChangePassword(false);
                setSavingNewPassword(false);
            }, (fail) => {
                if (fail.data !== undefined && fail.data["passDoesNotMatch"]) {
                    setIsOldPasswordValid(false);
                    buildCSSFormGroupInputTarget(oldPasswordInput.current, "changePasswordOldPasswordFormGroup", "changePasswordOldPasswordFormGroupError", false);
                    setSavingNewPassword(false);
                }
            });
        }
    }

    return (
        <div className="account__section">
            <div className="account__section__colLeft">
                <div className="account__section__colLeft_title">Credentials</div>
                <div className="account__section__colLeft_description"></div>
            </div>
            <div className="account__section__colRight">
                <form action="" className="form">
                    <div className="form__group">
                        <div className="form__group__input">
                            <input
                                className="form__group__input__text"
                                type="email"
                                placeholder={userEmail}
                                readOnly />
                            <span className="form__group__input__icon"><img
                                src="./assets/img/login_page/mail.png" alt="" /></span>
                        </div>
                        <span className="form__group__error form__group__error--email">Wrong Name</span>
                    </div>
                    <div className="form__action">
                        <a
                            href=""
                            onClick={openChangePasswordForm}
                            className="form__action__password">Change password</a>
                    </div>
                    {displayChangePassword &&
                        <>
                            <br/>
                            <div className="form__change__password">
                                <label className="form__label" htmlFor="">Current password</label>
                                <div className="form__group" id="changePasswordOldPasswordFormGroup">
                                    <div className="form__group__input">
                                        <input
                                            className="form__group__input__text form__group__input__text--noIcon"
                                            type={showOldPassword ? "text" : "password"}
                                            ref={oldPasswordInput}
                                            value={oldPassword}
                                            disabled={savingNewPassword}
                                            onChange={onChangeOldPassword} />
                                        <span className="form__group__input__toggle" onClick={toggleShowOldPassword}></span>
                                    </div>
                                    <span className="form__group__error form__group__error--email" id="changePasswordOldPasswordFormGroupError">
                                        Incorrect password!
                                    </span>
                                </div>
                                <label className="form__label" htmlFor="">New password</label>
                                <div className="form__group" id="changePasswordNewPasswordFormGroup">
                                    <div className="form__group__input">
                                        <input
                                            className="form__group__input__text form__group__input__text--noIcon"
                                            type={showNewPassword ? "text" : "password"}
                                            value={newPassword}
                                            disabled={savingNewPassword}
                                            onChange={onChangeNewPassword} />
                                        <span className="form__group__input__toggle" onClick={toggleShowNewPassword}></span>
                                    </div>
                                    <span className="form__group__error form__group__error--email" id="changePasswordNewPasswordFormGroupError">
                                        Please enter at least 8 characters!
                                    </span>
                                </div>
                                <br/>
                                { savingNewPassword ?
                                    (<LoadingIndicator/>):
                                    (
                                        <div className="cta__wrapp cta__wrapp--left pt-xs">
                                            <a
                                                href="#"
                                                onClick={onSaveButtonClick}
                                                className="cta--normal cta--notransform">Save</a>
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    }
                </form>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        userId: state.user.user.userId
    };
};

export default connect(mapStateToProps)(withToastManager(CredentialsSection));
